var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { StoreContext } from '@/app/uistore/Rootstore';
import { Box, Button, Center, Drawer, DrawerBody, DrawerContent, DrawerHeader, DrawerOverlay, Flex, HStack, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import React from 'react';
import { MediaControl } from '@/media/MediaControl';
import { Footer } from '@/media/MediaFooter';
import { MainScreen } from '@/media/MediaScreen';
let MediaCall = class MediaCall extends React.Component {
    onClose() {
        const rstore = this.context;
        rstore.mediastore.setOpen(false);
        rstore.mediastore.setActiveCall(false);
    }
    hideMeeting() {
        const rstore = this.context;
        rstore.mediastore.setShowHiddenBox(true);
        rstore.mediastore.setOpen(false);
    }
    render() {
        const rstore = this.context;
        return React.createElement(Drawer, { placement: 'bottom', size: 'full', onClose: () => this.onClose(), isOpen: rstore.mediastore.open },
            React.createElement(DrawerOverlay, null),
            React.createElement(DrawerContent, null,
                React.createElement(DrawerHeader, { borderBottomWidth: "1px" },
                    React.createElement(HStack, { spacing: "24px", w: '100%' },
                        React.createElement(Box, { w: '33%' },
                            React.createElement(Text, { fontWeight: 'bold', fontSize: '20px' }, "Active Meeting")),
                        React.createElement(Box, { w: '33%' },
                            React.createElement(Center, { w: '100%' },
                                React.createElement(MediaControl, null))),
                        React.createElement(Box, { w: '33%' },
                            React.createElement(Flex, { flexDirection: 'row', justify: 'flex-end', color: 'red', w: '100%', align: 'center' },
                                React.createElement(Button, { variant: 'unstyled', onClick: () => this.hideMeeting() }, "Hide"))))),
                React.createElement(DrawerBody, { backgroundColor: 'black' },
                    React.createElement(Box, { h: '60%', maxH: '60%' },
                        React.createElement(MainScreen, null)),
                    React.createElement(Box, { position: 'absolute', bottom: '15px', w: '100%', h: '150px' },
                        React.createElement(Footer, null)))));
    }
};
MediaCall.contextType = StoreContext;
MediaCall = __decorate([
    observer
], MediaCall);
export { MediaCall };
